import {
  SET_BANNER_AND_HEADER_HEIGHT,
  SET_HEADER_HEIGHT,
  SIGNPOSTINGBAR_VISIBLE,
} from "../actions/mega-nav";

const initialState = {
  headerHeight: 0,
  bannerHeight: 0,
  isSignpostingBarVisible: false,
};

const headerBanner = (state = initialState, action) => {
  switch (action.type) {
    case SET_BANNER_AND_HEADER_HEIGHT:
      return {
        ...state,
        headerHeight: action.payload.headerHeight,
        bannerHeight: action.payload.bannerHeight,
      };
    case SET_HEADER_HEIGHT:
      return {
        ...state,
        headerHeight: action.payload.headerHeight,
      };
    case SIGNPOSTINGBAR_VISIBLE:
      return {
        ...state,
        isSignpostingBarVisible: action.isSignpostingBarVisible,
      };
  }

  return state;
};

export default headerBanner;
